module.exports = __webpack_public_path__ + "img/no-data.504676a1.png";